import type { ReactNode } from 'react'

interface ContainerProps {
  children: ReactNode
  /**
   * Drop the side inset so a horizontal scroller can reach the container edge.
   * The section then applies the inset to its own header and scroller instead.
   *
   * A prop rather than a `px-*` override because there is no tailwind-merge
   * here — a competing class would resolve by CSS source order, not by intent.
   */
  bleed?: boolean
  /** Background, vertical rhythm, layout — anything except the side inset. */
  className?: string
}

/** The page grid every section aligns to. */
export const Container = ({
  children,
  bleed = false,
  className = '',
}: ContainerProps) => (
  <div
    className={`mx-auto w-full max-w-345 ${bleed ? '' : 'px-6 md:px-25'} ${className}`}
  >
    {children}
  </div>
)
